import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, CONTACT } from "../../lib/data";
import logoWhite from "../../assets/logo-white-transparent.png";

export const Navbar = ({ onNav }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => { setOpen(false); onNav(id); };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      style={{
        position: "fixed", top: 0, left: 0, width: "100%", zIndex: 1000,
        padding: scrolled ? "12px 0" : "22px 0",
        background: scrolled ? "rgba(14,14,14,0.78)" : "transparent",
        backdropFilter: scrolled ? "blur(14px) saturate(160%)" : "none",
        boxShadow: scrolled ? "0 8px 30px rgba(0,0,0,0.25)" : "none",
        transition: "all .4s cubic-bezier(.22,1,.36,1)",
      }}
      data-testid="site-header"
    >
      <div className="container" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <button onClick={() => go("home")} data-testid="nav-logo"
          style={{ display: "flex", alignItems: "center", gap: 10, color: "#fff",
            fontFamily: "'Bebas Neue'", fontSize: 24, letterSpacing: "0.08em" }}>
          <img src={logoWhite} alt="VLA lion crest" style={{ width: 42, height: 42, objectFit: "contain" }} /> VLA
        </button>

        <nav className="nav-desktop" style={{ display: "flex", gap: 34, alignItems: "center" }}>
          {NAV_LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} data-testid={`nav-link-${l.id}`}
              className="nav-underline"
              style={{ color: "#e9e9e6", fontSize: 13.5, fontWeight: 600,
                letterSpacing: "0.03em", textTransform: "uppercase" }}>
              {l.label}
            </button>
          ))}
        </nav>

        <div className="nav-cta-desktop" style={{ display: "flex", gap: 12, alignItems: "center" }}>
          <button className="btn btn-outline" onClick={() => go("contact")} data-testid="nav-contact-btn"
            style={{ padding: "12px 22px", fontSize: 12.5 }}>Contact</button>
          <button className="btn btn-gold" onClick={() => go("contact")} data-testid="nav-trial-btn"
            style={{ padding: "12px 22px", fontSize: 12.5 }}>Book Free Trial</button>
        </div>

        <button className="burger-btn" aria-label="Open menu" data-testid="mobile-menu-toggle"
          onClick={() => setOpen((o) => !o)}
          style={{ display: "none", color: "#fff" }}>
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.3 }}
            data-testid="mobile-menu"
            style={{ position: "fixed", top: 70, left: 16, right: 16, background: "rgba(14,14,14,0.97)",
              backdropFilter: "blur(14px)", borderRadius: 18, padding: 22, zIndex: 999,
              border: "1px solid rgba(242,169,59,0.25)" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              {NAV_LINKS.map((l, i) => (
                <motion.button key={l.id} onClick={() => go(l.id)} data-testid={`mobile-nav-link-${l.id}`}
                  initial={{ opacity: 0, x: -14 }} animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: i * 0.05 }}
                  style={{ color: "#e9e9e6", fontSize: 16, fontWeight: 600, textAlign: "left",
                    padding: "12px 6px", textTransform: "uppercase", letterSpacing: "0.04em" }}>
                  {l.label}
                </motion.button>
              ))}
              <button className="btn btn-gold" onClick={() => go("contact")} data-testid="mobile-trial-btn"
                style={{ marginTop: 12, width: "100%" }}>Book Free Trial</button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
